// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"ad96c20f","726":"ef917f64","821":"39220709"}[chunkId] + ".chunk.js";
};